// import axios from "axios";
// import { API_ENDPOINTS } from "../api-urls";


// // ** Helper function to get token **
// const getAuthToken = () => {
//   const token = localStorage.getItem("authToken");
//   return token ? `Bearer ${token}` : null;
// };

// // ** Fetch All Addresses **
// export const fetchAddressesAPI = async () => {
//   const token = getAuthToken();
//   if (!token) throw new Error("Authentication token missing.");

//   const response = await axios.get(`${API_ENDPOINTS.addresses}/get-allUserAddresses`, {
//     headers: { Authorization: token },
//   });

//   return response.data.addresses;
// };

// // ** Add New Address **
// export const addNewAddressAPI = async (addressData) => {
//   const token = getAuthToken();
//   if (!token) throw new Error("Authentication token missing.");

//   const response = await axios.post(`${API_ENDPOINTS.addresses}/add-address`, addressData, {
//     headers: { Authorization: token },
//   });

//   return response.data.address;
// };

// // ** Update Address **
// export const updateAddressAPI = async (id, updatedAddress, userId) => {
//   if (!userId) throw new Error("User ID is required.");

//   const response = await axios.put(
//     `${API_ENDPOINTS.addresses}/update-address/${id}`,
//     { ...updatedAddress, _id: id, user_id: userId },
//     { headers: { Authorization: getAuthToken() } }
//   );

//   return response.data;
// };

// // ** Delete Address **
// export const deleteAddressAPI = async (id) => {
//   const token = getAuthToken();
//   if (!token) throw new Error("Authentication token missing.");

//   const response = await axios.delete(`${API_ENDPOINTS.addresses}/delete-address/${id}`, {
//     headers: { Authorization: token },
//   });

//   return response.status === 200 || response.data.success ? id : null;
// };


import axios from "axios";
import { API_ENDPOINTS } from "../api-urls";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// ** Helper function to get token **
const getAuthToken = () => {
  const token = localStorage.getItem("authToken");
  return token ? `Bearer ${token}` : null;
};

// ** Helper function to get stored default address **
const getStoredDefaultAddress = () => {
  const storedAddress = localStorage.getItem("defaultAddress");
  return storedAddress ? JSON.parse(storedAddress) : null;
};

// ** Fetch All Addresses **
export const fetchAddressesAPI = async () => {
  const token = getAuthToken();
  if (!token) throw new Error("Authentication token missing.");

  const response = await axios.get(
    `${API_ENDPOINTS.addresses}/get-allUserAddresses`,
    { headers: { Authorization: token } }
  );

  return response.data.addresses || [];
};

// ** Add New Address **
export const addNewAddressAPI = async (addressData) => {
  const token = getAuthToken();
  if (!token) throw new Error("Authentication token missing.");

  const response = await axios.post(
    `${API_ENDPOINTS.addresses}/add-address`,
    addressData,
    { headers: { Authorization: token } }
  );

  return response.data.address;
};

// ** Update Address **
export const updateAddressAPI = async (id, updatedAddress, userId) => {
  if (!userId) throw new Error("User ID is required.");

  const response = await axios.put(
    `${API_ENDPOINTS.addresses}/update-address/${id}`,
    { ...updatedAddress, _id: id, user_id: userId },
    { headers: { Authorization: getAuthToken() } }
  );

  return response.data.address;
};

// ** Delete Address **
export const deleteAddressAPI = async (id) => {
  const token = getAuthToken();
  if (!token) throw new Error("Authentication token missing.");

  const response = await axios.delete(
    `${API_ENDPOINTS.addresses}/delete-address/${id}`,
    { headers: { Authorization: token } }
  );

  return response.status === 200 || response.data.success ? id : null;
};
// ** Update Default Shipping Address **
export const updateDefaultAddressAPI = async (addressId) => {
  const token = getAuthToken();
  if (!token) throw new Error("Authentication token missing.");

  const response = await axios.post(
    `${API_ENDPOINTS.addresses}/defaultAddress/${addressId}`,
    {},
    { headers: { Authorization: token } }
  );

  return response.data.address;
};


// ** Fetch Addresses Thunk **
export const fetchAddresses = createAsyncThunk(
  "address/fetchAddresses",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchAddressesAPI();
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch addresses");
    }
  }
);

// ** Add New Address Thunk **
export const addNewAddress = createAsyncThunk(
  "address/addNewAddress",
  async (addressData, { dispatch, rejectWithValue }) => {
    try {
      const newAddress = await addNewAddressAPI(addressData);
      const storedDefaultAddress = getStoredDefaultAddress();

      if (!storedDefaultAddress) {
        localStorage.setItem("defaultAddress", JSON.stringify(newAddress));
        dispatch(setDefaultAddress(newAddress));
      }

      return newAddress;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to add address");
    }
  }
);

// ** Update Address Thunk **
// ** Update Address Thunk **
export const updateExistingAddress = createAsyncThunk(
  "address/updateAddress",
  async ({ id, updatedAddress }, { getState, rejectWithValue }) => {
    try {
      const userId = getState().auth?.user?.id || getState().auth?.user?.user?.id;
      if (!userId) throw new Error("User ID is missing.");
      
      const updatedAddr = await updateAddressAPI(id, updatedAddress, userId);
      
      // Check if the updated address is the default one before updating defaultAddress
      const currentDefault = getState().address.defaultAddress;
      if (currentDefault && currentDefault._id === id) {
        localStorage.setItem("defaultAddress", JSON.stringify(updatedAddr));
        return updatedAddr;
      }

      return updatedAddr;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to update address");
    }
  }
);


// ** Delete Address Thunk **
export const deleteAddress = createAsyncThunk(
  "address/deleteAddress",
  async (id, { getState, dispatch, rejectWithValue }) => {
    try {
      const deletedId = await deleteAddressAPI(id);
      if (deletedId) {
        const state = getState().address;
        if (state.defaultAddress && state.defaultAddress._id === deletedId) {
          const newDefault = state.savedAddresses.length ? state.savedAddresses[0] : null;
          dispatch(setDefaultAddress(newDefault));
          localStorage.setItem("defaultAddress", newDefault ? JSON.stringify(newDefault) : null);
        }
      }
      return deletedId;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to delete address");
    }
  }
);

// ** Update Default Address Thunk **
export const updateDefaultAddress = createAsyncThunk(
  "address/updateDefaultAddress",
  async (addressId, { dispatch, rejectWithValue }) => {
    try {
      const updatedAddress = await updateDefaultAddressAPI(addressId);
      localStorage.setItem("defaultAddress", JSON.stringify(updatedAddress));
      dispatch(setDefaultAddress(updatedAddress));
      return updatedAddress;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to update default address");
    }
  }
);


// ** Initial State **
const initialState = {
  defaultAddress: getStoredDefaultAddress(),
  shippingAddress: null,
  billingAddress: null,
  savedAddresses: [],
  useSameAsShipping: true,
  loading: false,
  error: null,
};

// ** Address Slice **
const addressSlice = createSlice({
  name: "address",
  initialState,
  reducers: {
    setDefaultAddress: (state, action) => {
      state.defaultAddress = action.payload;
      localStorage.setItem("defaultAddress", action.payload ? JSON.stringify(action.payload) : null);
    },
    setShippingAddress: (state, action) => {
      state.shippingAddress = action.payload;
    },
    setBillingAddress: (state, action) => {
      state.billingAddress = action.payload;
    },
    toggleUseSameAsShipping: (state) => {
      state.useSameAsShipping = !state.useSameAsShipping;
    },
    initializeDefaultAddress: (state) => {
      const storedAddress = getStoredDefaultAddress();
      if (storedAddress) {
        state.defaultAddress = storedAddress;
      }
    },
    removeAllAddresses: (state) => {
      state.defaultAddress = null;
      state.shippingAddress = null;
      state.billingAddress = null;
      state.savedAddresses = [];
      localStorage.removeItem("defaultAddress");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAddresses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAddresses.fulfilled, (state, action) => {
        state.loading = false;
        state.savedAddresses = action.payload;
      })
      .addCase(fetchAddresses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addNewAddress.fulfilled, (state, action) => {
        state.savedAddresses.push(action.payload);
        if (!state.defaultAddress) {
          state.defaultAddress = action.payload;
          localStorage.setItem("defaultAddress", JSON.stringify(action.payload));
        }
      })
      .addCase(addNewAddress.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateExistingAddress.fulfilled, (state, action) => {
        state.savedAddresses = state.savedAddresses.map((address) =>
          address._id === action.payload._id ? action.payload : address
        );
        if (state.defaultAddress && state.defaultAddress._id === action.payload._id) {
          state.defaultAddress = action.payload;
          localStorage.setItem("defaultAddress", JSON.stringify(action.payload)); // Store it
        }
      })
      .addCase(updateExistingAddress.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(deleteAddress.fulfilled, (state, action) => {
        if (action.payload) {
          state.savedAddresses = state.savedAddresses.filter(
            (address) => address._id !== action.payload
          );
        }
      })
      .addCase(deleteAddress.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateDefaultAddress.fulfilled, (state, action) => {
        state.defaultAddress = action.payload;
        localStorage.setItem("defaultAddress", JSON.stringify(action.payload));
      })
      .addCase(updateDefaultAddress.rejected, (state, action) => {
        state.error = action.payload;
      });
;
  },
});

// ** Export Actions **
export const { setDefaultAddress, setShippingAddress, setBillingAddress, toggleUseSameAsShipping, removeAllAddresses } =
  addressSlice.actions;

// ** Export Reducer **
export default addressSlice.reducer;

